import LodChlSelect from "components/select/lod/lodChl";
import RmNmSelect from "components/select/rm/rmNo";
// import DatePick from "components/datePick";
import TableRow from "components/rows/tableRow";
import { useTranslation } from "react-i18next";
import { SEARCH_FORM_ID_ROOM_HISTORY } from "components/constent";
import { useProductHistoryFilterContext } from "./context";
import { useSubmit } from "./handles";
import Cell from "components/rows/cell";
import DateRangePicker from "components/datePicker";

export default function SearchForm() {
  const { t } = useTranslation();
  const { filters, onChange, onSelect, onPickDate, onReset } =
    useProductHistoryFilterContext();

  const { onSubmit } = useSubmit();

  return (
    <>
      <form
        id={SEARCH_FORM_ID_ROOM_HISTORY}
        onSubmit={onSubmit}
        onReset={onReset}
      >
        <table>
          <tbody>
            {/* <LodInfRow /> */}
            <TableRow title={t("row_ttl_rm_inf")}>
              <ul>
                <li>
                  <label htmlFor="">{t("lbl_rm_nm")}</label>
                  <RmNmSelect
                    isReset={!filters.rmNo}
                    select={(rmNo) => {
                      onSelect("rmNo", rmNo);
                    }}
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_rm_op_nm")}
                    dataTyp="C"
                    name="rmOpNm"
                    value={filters.rmOpNm}
                    onChange={(e) => onChange("rmOpNm", e.currentTarget.value)}
                  />
                </li>
                {/* <li>
                  <label htmlFor="">{t("lbl_rm_typ")}</label>
                  <RmTypCdSelect
                    isReset={!filters.rmTypCd}
                    select={(rmTypCd) => onSelect("rmTypCd", rmTypCd)}
                  />
                </li>
                <li>
                  <label htmlFor="">{t("lbl_rm_olk")}</label>
                  <RmOlkCdSlect
                    isReset={!filters.rmOlkCd}
                    select={(rmOlkCd) => onSelect("rmOlkCd", rmOlkCd)}
                  />
                </li> */}
              </ul>
            </TableRow>
            <TableRow title={t("row_ttl_rm_pd")}>
              <ul>
                <li>
                  <label htmlFor="">{t("lbl_rmpd_chl")}</label>
                  <LodChlSelect
                    isReset={!filters.lodChlCd}
                    select={(lodChlCd) => onSelect("lodChlCd", lodChlCd)}
                  />
                </li>
                <li>
                  <DateRangePicker
                    startNm="sellSDt"
                    endNm="sellEDt"
                    defaultStart={filters.sellSDt}
                    defaultEnd={filters.sellEDt}
                    onChange={onPickDate}
                  />
                  {/* <DatePick
                    startNm="sellSDt"
                    endNm="sellEDt"
                    defaultValue={[filters.sellSDt, filters.sellEDt]}
                    onPickDate={onPickDate}
                  /> */}
                </li>
              </ul>
            </TableRow>
          </tbody>
        </table>
      </form>
    </>
  );
}
